import api from './api';

const administrateurService = {
  getAll: async () => {
    try {
      return await api.get('/administrateurs');
    } catch (e) {
      return await api.get('/admin/administrateurs');
    }
  },

  getById: async (id) => {
    try {
      return await api.get(`/administrateurs/${id}`);
    } catch (e) {
      return await api.get(`/admin/administrateurs/${id}`);
    }
  },

  create: async (data) => {
    try {
      return await api.post('/administrateurs', data);
    } catch (e) {
      return await api.post('/admin/administrateurs', data);
    }
  },

  update: async (id, data) => {
    try {
      return await api.put(`/administrateurs/${id}`, data);
    } catch (e) {
      return await api.put(`/admin/administrateurs/${id}`, data);
    }
  },

  delete: async (id) => {
    try {
      return await api.delete(`/administrateurs/${id}`);
    } catch (e) {
      return await api.delete(`/admin/administrateurs/${id}`);
    }
  },

  envoyerIdentifiants: async (id, password = null, email = null, name = null) => {
    const payload = { password, email, name };
    try {
      return await api.post(`/administrateurs/${id}/envoyer-identifiants`, payload);
    } catch (e) {
      return await api.post(`/admin/administrateurs/${id}/envoyer-identifiants`, payload);
    }
  }
};

export default administrateurService;
